import { VStack, Box, HStack, Icon, Text, Input } from '@chakra-ui/react';
import { Field } from '@/components/ui/field';
import { Avatar } from '@/components/ui/avatar';
import { RiWhatsappLine } from 'react-icons/ri';

interface ConfirmDetailProps {
  channelName: string;
  onChannelNameChange: (name: string) => void;
  businessName?: string;
  businessPhone?: string;
}

export function ConfirmDetail({
  channelName,
  onChannelNameChange,
  businessName = 'WhatsApp Business Account',
  businessPhone = 'Connecting...',
}: ConfirmDetailProps) {
  return (
    <VStack gap={6} align="stretch" maxW="500px" mx="auto">
      {/* Connected Account Info */}
      <Box p={4} borderWidth="1px" borderRadius="md" backgroundColor="gray.50">
        <HStack gap={4}>
          <Avatar>
            <Icon as={RiWhatsappLine} color="white" />
          </Avatar>
          <Box>
            <Text fontWeight="bold">{businessName}</Text>
            <Text color="gray.600">{businessPhone}</Text>
          </Box>
        </HStack>
      </Box>

      {/* Channel Name Input */}
      <Field label="Channel Name" required>
        <Input
          placeholder="Enter channel name"
          value={channelName}
          onChange={(e) => onChannelNameChange(e.target.value)}
        />
      </Field>

      {/* Success Message */}
      <Box p={4} bg="green.50" borderRadius="md">
        <Text color="green.700">
          Great! Your WhatsApp Business account is connected. You can now use
          all business features.
        </Text>
      </Box>
    </VStack>
  );
}
